// extracted by mini-css-extract-plugin
export default {"wrapper":"ImagenConsultant_wrapper__fHwyt","background":"ImagenConsultant_background__OGCxg"};